export default __webpack_public_path__ + "static/media/amacas de catarina.ff83cc97.jpg";